<app-page-content [enableMenuButton]="true" [showProgress]="progress">
  <span pagetitle>Tildel turer til bruker</span>

  <div pagecontent>
    <app-order-table #orderTable
      [sortColumn]="currentSortDirection"
      [sortDirection]="currentSortDirection"
      (sortChanged)="sortChanged($event)"
      [multipleSelect]="multipleSelectEnabled"
      (selectionToggled)="onSelectionToggled($event)"
      (assignOrder)="assignOrders([$event])"
      (unassignOrder)="queryUnassignOrders([$event])"
      [showAssignColumn]="!multipleSelectEnabled"
      [orders]="orders"></app-order-table>
  </div>

  <div style="display: flex;" pagefooter>
    <app-button-box style="margin: auto">
      <button mat-raised-button color="primary" *ngIf="selectedOrders.length == 0" (click)="toggleMultipleSelect()">
        {{ multipleSelectEnabled ? 'VELG EN' : 'VELG FLERE' }}
      </button>
      <button mat-raised-button color="primary" *ngIf="selectedOrders.length > 0" (click)="clearSelection()">NULLSTILL</button>
      <button mat-raised-button color="primary" *ngIf="selectedOrders.length > 0" (click)="assignSelectedOrders()">
        TILDEL
      </button>
      <button mat-raised-button color="warn" *ngIf="selectedOrders.length > 0" (click)="unassignSelectedOrders()">
        FJERN TILDELING
      </button>
    </app-button-box>

    <span style="flex: 1 1 auto"></span>

    <app-paginator [totalCount]=totalOrderCount
                   [pageSize]=currentPageSize
                   [pageSizeOptions]="[20, 50, 100, 200]"
                   [pageIndex]=currentPage
                   (page)="changePage($event)">
    </app-paginator>
  </div>
</app-page-content>
